import { register, NdsChatMap } from './widget';

register();

declare global {
  interface Window {
    NdsChatMap?: typeof NdsChatMap;
  }
}
window.NdsChatMap = NdsChatMap;

export { NdsChatMap, register };
